var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',_vm._g(_vm._b({style:({ maxWidth: _vm.maxWidth }),attrs:{"controls":"","controlsList":"nodownload"},on:{"canplaythrough":function($event){return _vm.$emit('load')}}},'audio',_vm.$attrs,false),_vm.$listeners),[_c('source',{attrs:{"preload":"auto","src":_vm.src,"type":"audio/mpeg"}}),_vm._v(" הדפדפן שלך אינו תומך ברכיב האודיו ")])
}
var staticRenderFns = []

export { render, staticRenderFns }